import React from "react";
import { Fab } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CONTACT_INFO from "../constants/contactInfo";
const WhatsAppButton = () => {
  return (
    <Fab
      color="primary"
      aria-label="whatsapp"
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        bgcolor: "#25D366",
        "&:hover": {
          bgcolor: "#128C7E",
        },
      }}
      onClick={() => window.open(CONTACT_INFO.whatsappLink, "_blank")}
    >
      <WhatsAppIcon />
    </Fab>
  );
};

export default WhatsAppButton;
